<template>
  <div class="d-flex justify-center" style="width: 75px">
    <v-progress-circular
      :value="valor"
      :color="cor"
      :size="tamanho"
      :width="largura"
      class="my-1"
    >
      <span v-if="statusProduto !== 'RUPTURA'" style="color: black">
        {{formatarValor(valor)}}%
      </span>
      <span v-else style="color: red">
        0%
      </span>
    </v-progress-circular>
  </div>
</template>

<script>
import formatador from "./grafico/Formatter";

export default {
  name: "NivelEstoqueProgressCircular",
  props: {
    valor: {
      type: [String, Number],
      default: 0
    },
    statusProduto: {
      type: String,
      default: ''
    },
    tamanho: {
      type: Number,
      default: 52
    },
    largura: {
      type: Number,
      default: 7
    }
  },
  data: () => ({
    produto: {
      idproduto: 1,
      descricao: 'teste'
    }
  }),
  computed: {
    cor() {
      let cor;

      switch (this.statusProduto) {
        case 'EXCESSO':
          cor = '#042333E5';
          break;
        case 'RUPTURA':
          cor = '#FD0001FF';
          break;
        case 'ADEQUADO':
          cor = '#00AE51FF';
          break;
        case 'BAIXA EXPOSIÇÃO A RUPTURA':
          cor = '#FFFE02FF';
          break;
        case 'ALTA EXPOSIÇÃO A RUPTURA':
          cor = '#FF9B05EF';
          break;

        default:
          cor = '#C7C7C7EF';
      }

      return cor;
    }
  },
  methods: {
    formatarValor(valor) {
      if (Math.ceil(valor) === 0) {
        return 0;
      }

      return formatador(Math.ceil(valor))
    }
  }
}
</script>

<style scoped>

</style>
